import "./Header.module.scss";

export const Header = () => {
  return (
    <div className="header">
      <div className="text">www.caninogroupitalia.it</div>
    </div>
  );
};